<template>
  <div class="user-login-main">
    <div id="particles_bg" class="page-bg"></div>
    <div class="login-box">
      <div class="login-title-wrap">
        <div class="title">Welcome to log in</div>
        <!-- <div class="sub-title">欢迎登录</div> -->
      </div>
      <div class="form-fill-wrap">
        <div class="form-item hf">
          <div class="ipt-wrap ftp">
            <i class="icon-label fa fa-user ftp"></i>
            <input class="ipt" type="text" placeholder="Please enter user name" v-model="username" />
          </div>
        </div>
        <div class="form-item hf">
          <div class="ipt-wrap ftp">
            <i class="icon-label fa fa-lock ftp"></i>
            <input class="ipt" type="password" placeholder="Please enter your password" v-model="password" />
          </div>
        </div>
        <div class="login-btn" @click="doLogin">Login</div>
      </div>
    </div>
  </div>
</template>

<script>
import tools from '@/components/common/tools'
import user from '@/components/common/user'

// 请求相关操作
let page = {
  methods: {
    // 用户登录
    userLoginAjax() {
      tools.commonAjax.call(this, 0, '/Login/AdminLoginInWeb', {
        username: this.username,
        password: this.password
      }).then((res) => {
        user.setMemberToken(res.description)
        this.$router.push('/Welcome')
      })
    }
  }
}

export default {
  name: 'Login',
  mixins: [page],
  mounted() {
    this.initBg()
  },
  components: {
  },
  data() {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    doLogin() {
      this.userLoginAjax()
    },
    initBg() {
      window.particlesJS('particles_bg', {
        'particles': {
          'number': {
            'value': 100,
            'density': {
              'enable': true,
              'value_area': 1000
            }
          },
          'color': {
            'value': ['#aa73ff', '#f8c210', '#83d238', '#33b1f8']
          },

          'shape': {
            'type': 'circle',
            'stroke': {
              'width': 0,
              'color': '#fff'
            },
            'polygon': {
              'nb_sides': 5
            },
            'image': {
              'src': 'img/github.svg',
              'width': 100,
              'height': 100
            }
          },
          'opacity': {
            'value': 0.6,
            'random': false,
            'anim': {
              'enable': false,
              'speed': 1,
              'opacity_min': 0.1,
              'sync': false
            }
          },
          'size': {
            'value': 2,
            'random': true,
            'anim': {
              'enable': false,
              'speed': 40,
              'size_min': 0.1,
              'sync': false
            }
          },
          'line_linked': {
            'enable': true,
            'distance': 120,
            'color': '#ffffff',
            'opacity': 0.4,
            'width': 1
          }
        },
        'interactivity': {
          'detect_on': 'canvas',
          'events': {
            'onhover': {
              'enable': true,
              'mode': 'grab'
            },
            'onclick': {
              'enable': false
            },
            'resize': true
          },
          'modes': {
            'grab': {
              'distance': 140,
              'line_linked': {
                'opacity': 1
              }
            },
            'bubble': {
              'distance': 400,
              'size': 40,
              'duration': 2,
              'opacity': 8,
              'speed': 3
            },
            'repulse': {
              'distance': 200,
              'duration': 0.4
            },
            'push': {
              'particles_nb': 4
            },
            'remove': {
              'particles_nb': 2
            }
          }
        },
        'retina_detect': true
      })
    }
  }
}
</script>

<style lang='scss'>
@import '~@/style/config';
</style>



// WEBPACK FOOTER //
// Login.vue?745881f2